module.exports = __webpack_public_path__ + "static/media/platycleis_grisea_005_APA.3b88c575.mp3";